import React, { useState } from 'react';
import { Tooltip } from 'antd';
import LLMJobTagImage from '../../../../assets/img/llm-job-tag.svg'
import InfoOutlined from '../../../../assets/img/info-outlined.svg'
import './jobCard.scss';


export const JobTag = ({
    text,
    tooltipText,
    image = null,
    status = "INFO"
}) => {
    const [_, setTooltipVisible] = useState(false);
    const handleTooltipVisibleChange = (visible) => {
        setTooltipVisible(visible);
    };
    return (
        <Tooltip
            onVisibleChange={handleTooltipVisibleChange}
            title={tooltipText}
        >
            <span className={`tag tag--${status}`}>
                <span className="tag-image">{image}</span>
                <span>{text}</span>
            </span>
        </Tooltip>

    )
}

export const LLMJobTag = ({
    text,
    tooltipText,
}) => (
    <JobTag 
        status="INFO" 
        image={<img src={LLMJobTagImage} />} 
        text={text}
        tooltipText={tooltipText}
    />
)

export const UnderReviewTag = ({
    text,
    tooltipText
}) => (
    <JobTag 
        status="DEFAULT" 
        image={<img src={InfoOutlined} />} 
        text={text}
        tooltipText={tooltipText}
    />
)

export const BetaTag = ({
    text,
    tooltipText,
}) => (
    <JobTag 
        status="BETA"
        text={text}
        tooltipText={tooltipText}
    />
)